import { render, staticRenderFns } from "./FeatureV2.vue?vue&type=template&id=03a37c88"
import script from "./FeatureV2.vue?vue&type=script&lang=js"
export * from "./FeatureV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports